import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const openModal = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.click();
  };

  return (
    <footer className="mgs-footer" role="contentinfo">
      <div className="mgs-footer__inner">
        {/* Marca */}
        <div className="mgs-footer__brand">
          <span className="mgs-footer__logo">
            MagriSim<sup>®</sup>
          </span>
          <p className="mgs-footer__tagline">
            Fórmula natural em gotas para auxiliar na sua jornada de emagrecimento.
          </p>
          <div className="mgs-footer__socials">
            <a
              href="https://www.facebook.com/share/1GNpkSozoZ/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="mgs-footer__social"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/magri_sim?igsh=MXZ3OWN6cmt2bzRsaw=="
              target="_blank"
              rel="noopener noreferrer"
              className="mgs-footer__social"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.tiktok.com/@magrisimoficial?_t=ZM-8zF0de6rFUD&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="mgs-footer__social"
              aria-label="TikTok"
            >
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>

        {/* Colunas */}
        <div className="mgs-footer__cols">
          <div className="mgs-footer__col">
            <h4>Navegação</h4>
            <ul>
              <li><a href="#hero">O que é MagriSim?</a></li>
              <li><a href="#faq">Perguntas frequentes</a></li>
              <li><a href="#pain-points">Depoimentos</a></li>
              <li><a href="#offer">Comprar agora</a></li>
            </ul>
          </div>

          <div className="mgs-footer__col">
            <h4>Atendimento</h4>
            <ul>
              <li>
                <i className="fab fa-whatsapp"></i>
                <a href="https://wa.me/553135687051" target="_blank" rel="noopener noreferrer">
                  (31) 3568-7051
                </a>
              </li>
              <li>
                <i className="fas fa-envelope"></i>
                <a href="mailto:contato@magrisim.com.br">contato@magrisim.com.br</a>
              </li>
              <li>
                <i className="fas fa-globe"></i>
                <span>www.magrisim.com.br</span>
              </li>
            </ul>
          </div>

          <div className="mgs-footer__col">
            <h4>Legal</h4>
            <ul>
              <li><a href="#termos-de-uso" onClick={openModal('termos-modal')}>Termos de Uso</a></li>
              <li><a href="#politica-privacidade" onClick={openModal('privacidade-modal')}>Política de Privacidade</a></li>
            </ul>
          </div>
        </div>

        {/* Dados da empresa (condensado) */}
        <div className="mgs-footer__company">
          <p><strong>MMP Ltda</strong> &middot; CNPJ 25.296.787/0001-01</p>
          <p>Rua Rio Grande do Norte, 726 – Sala 703, Funcionários, Belo Horizonte – MG, CEP 30130-131, Brasil</p>
        </div>

        {/* Aviso legal */}
        <div className="mgs-footer__legal">
          <p>
            Este site utiliza cookies para melhorar sua experiência. Ao continuar navegando, você
            concorda com nossa Política de Privacidade e Termos de Uso. Este site não faz parte do
            Facebook, Google, Instagram ou qualquer outra plataforma de mídia social.
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="mgs-footer__bottom">
        <p>&copy; {currentYear} MagriSim® &middot; MMP Ltda &middot; CNPJ: 25.296.787/0001-01 &middot; Todos os direitos reservados</p>
      </div>
    </footer>
  );
};

export default Footer;
